import { store as participant } from '@/modules/participant'

export default {
  participant
}
